import { GET_EXAM_IS_LOADING, GET_EXAM_LOAD_ERROR, GET_EXAM_LOAD_SUCCESS } from "../actions/action_types"

export default function examScheduleReducer(state = { getExamSchedules: [], isLoading: false, getExamSchedulesError: null }, action) {
    switch (action.type) {
        case GET_EXAM_IS_LOADING:
            return { ...state, isLoading: true }
        case GET_EXAM_LOAD_SUCCESS:
            return { ...state, getExamSchedules: action.payload, isLoading: false }
        case GET_EXAM_LOAD_ERROR:
            return { ...state, getExamSchedulesError: action.payload, isLoading: false }
        default:
            return state
    }
}